import { render } from "./FooterSection.vue?vue&type=template&id=fc5a4554&scoped=true"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import "./FooterSection.vue?vue&type=style&index=0&id=fc5a4554&scoped=true&lang=css"

import exportComponent from "/home/brandon/Code/Clients/PhilipComan/specialty-studio-vuetify-theme-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc5a4554"]])

export default __exports__